import PropTypes from "prop-types";
import React, { useState } from "react";
import Calendar from "react-calendar";
import IconPrevious from "solar/icons/IconPrevious";
import IconNext from "solar/icons/IconNext";
import styles from "components/shared/stays/Month.module.scss";

export default function Month({ initialMonth, setCurrentMonth }) {
  const [value, setValue] = useState(initialMonth);

  function handleMonthChange(val) {
    setCurrentMonth(val);
    setValue(val);
  }

  return (
    <div className={styles.component}>
      <Calendar
        onChange={handleMonthChange}
        value={value}
        maxDetail="year"
        minDetail="year"
        prevLabel={<IconPrevious />}
        nextLabel={<IconNext />}
        prev2Label={null}
        next2Label={null}
        minDate={new Date()}
      />
    </div>
  );
}

Month.propTypes = {
  initialMonth: PropTypes.instanceOf(Date),
  setCurrentMonth: PropTypes.func.isRequired,
};

Month.defaultProps = {
  initialMonth: new Date(),
};
